<template>
    <div class="container-fluid" v-if="rastreador && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS">
                <div class="col-sm-3">
                    <enviar-saidas :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <limpar-posicoes :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente" />
            </vk-tabs-item>



            <vk-tabs-item title="RELATÓRIOS">
                <dados-relatorios-admin :veiculo="veiculo" />
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">

                <br/>

                <vue-tabs>
                    <v-tab title="TEMPOS" v-if="config">
                        <br/>
                        <tempos-maxtrack :config="config"/>
                    </v-tab>
                </vue-tabs>
            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS">
                <div class="col-sm-3">
                    <enviar-saidas :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <limpar-posicoes :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>

    import LimparPosicoes from '../../components/buttons/LimparPosicoes';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import HeaderAdmin from './HeaderAdmin';
    import {Maxtrack} from '../../class/maxtrack';
    import TemposMaxtrack from './partials/maxtrack/TemposMaxtrack';
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import TableTelefonesClientes from '../tables/TableTelefonesClientes';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';

    export default {
        components: {
            DadosDoClienteAdmin,
            DadosRelatoriosAdmin,
            PositionsMaps,
            TableTelefonesClientes,
            Problemas,
            TemposMaxtrack, LimparPosicoes, HeaderAdmin,
            Reset, TableComandos,
            SolicitarConfiguracao, EnviarSaidas
        },

        data(){
            return {
                config: null
            }
        },

        mixins: [
            veiculosAdminMixins
        ],

        async beforeMount(){
            this.config = await Maxtrack.byPK(this.rastreador.id_rastreador);
        },

    }
</script>
